import React from "react";
import { Navigate, useParams } from "react-router-dom";

// <Navigate> that fills `:param` placeholders in `to` from the current route.
function RedirectWithParams({ to }) {
  const params = useParams();
  const path = Object.entries(params).reduce((acc, [key, value]) => acc.replace(`:${key}`, value), to);
  return <Navigate to={path} replace />;
}

export default RedirectWithParams;
